
export class TimelineHelper {
  readonly monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  public getTimelineLabel(type: string, date: string): string {
    if (type !== 'milestone') {
      let day = (date.substring(8, 10));
      let month = +(date.substring(5, 7));
      return this.monthNames[month - 1].substring(0, 3) + ' ' + day;
    }

    const year = +(date.substring(0, 4));
    const month = +(date.substring(5, 7));

    let milestoneLabel = this.monthNames[month - 1].substring(0, 3);
    if (month == 1) {
      milestoneLabel = year.toString();
    }
    return milestoneLabel;
  }

  public getTimelineAnchor(date: string): string {
    const year = +(date.substring(0, 4));
    const month = +(date.substring(5, 7));

    return year.toString() + ('0' + month.toString()).slice(-2);
  }

  public enableEditMode(type: string): boolean{
    switch (type) {
      case "session":
      case "classic-session":
      case "classic-progress":
      case "classic-ilp":
      case "progress-report":
      case "milestone-event":
        return false;
    
      default:
        return true;
    }
  }
}
